import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PageHeader } from '../../../shared/page-header/page-header';
import { AuthService } from '../../../core/auth/auth.service';
import { OrganizationService } from '../../../core/organization/organization.service';
import { Organization } from '../../../core/organization/organization.models';
import { Client } from '../../../core/client/client.models';
import { STATUS_LABELS, statusBadge } from '../../../core/client/client.labels';

@Component({
  selector: 'app-organization-detail',
  imports: [RouterLink, DatePipe, PageHeader],
  templateUrl: './organization-detail.html',
})
export class OrganizationDetail implements OnInit {
  private readonly service = inject(OrganizationService);
  private readonly route = inject(ActivatedRoute);
  protected readonly auth = inject(AuthService);

  protected readonly tenant = computed(() => this.auth.currentTenant() ?? '');

  protected readonly organization = signal<Organization | null>(null);
  protected readonly clients = signal<readonly Client[]>([]);
  protected readonly loading = signal(true);
  protected readonly error = signal<string | null>(null);

  protected readonly uploading = signal(false);
  protected readonly uploadError = signal<string | null>(null);

  protected readonly statusLabels = STATUS_LABELS;
  protected readonly statusBadge = statusBadge;

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.service.get(id).subscribe({
      next: (detail) => {
        this.organization.set(detail.organization);
        this.clients.set(detail.clients);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Não foi possível carregar a organização.');
        this.loading.set(false);
      },
    });
  }

  onLogoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const org = this.organization();
    if (!file || !org) return;

    this.uploading.set(true);
    this.uploadError.set(null);
    this.service.uploadLogo(org.id, file).subscribe({
      next: (updated) => {
        this.organization.set(updated);
        this.uploading.set(false);
        input.value = ''; // permite reenviar o mesmo arquivo
      },
      error: () => {
        this.uploadError.set('Não foi possível enviar o logo. Envie uma imagem (PNG, JPG, WEBP, GIF ou SVG) até 5MB.');
        this.uploading.set(false);
        input.value = '';
      },
    });
  }
}
